module.exports = __webpack_public_path__ + "fonts/hinted-Atma-SemiBold.997f7860.ttf";